/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('reviseorder').controller('reviseOrderCtrl', [ '$rootScope', '$scope', '$injector', '$state', 'mnpNbaProvider', function($rootScope, $scope, $injector, $state, mnpNbaProvider) {

        var vm = this;
        vm.$onInit = function () {
            vm.config = $injector.get('config');

            $rootScope.loading = true;
            vm.authenticated = false;
            vm.isPortingPossible = false;

            var nbaCall = mnpNbaProvider.checkSession();
            nbaCall.then(function() {
                $rootScope.loading = false;
                vm.authenticated = true;

                // TODO: implement revise order
            });
        };

    }
    ]);

})();
